import(/* webpackMode: "eager" */ "/home/click-builder/cresivox/live/builder/src/app/auth/(sign-up)/sign-up-1/register-screen.tsx")